module.exports = __webpack_public_path__ + "img/workwx_fws.2cd89ce7.png";